export default __webpack_public_path__ + "static/media/09.4ee2be55.jpg";